import axios from "axios";
import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Spinner from "react-bootstrap/Spinner";
// import StyledHero from './StyledHero';

import heroImage from "../Images/Banner.webp";

export default function Header() {
  const [subscriberEmail, setSubscriberEmail] = useState("");
  const [validEmail, setValidEmail] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modalText, setModalText] = useState("");

  const body = {
    email: subscriberEmail,
    campaignId: "sunwestconnect.com",
    userId: "REVM",
    date: "",
    time: "",
    unsubscribe: "1",
    accountConsent: "1",
    marketingConsent: "1",
    notes: "sample notes - all false",
    loanNumber: "",
    webLeadNumber: "",
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validEmail) {
      e.stopPropagation();
    } else {
      setLoading(true);
      setModalText(
        <>
          <p>One moment while we set up your subscription.</p>
          <Spinner animation="border" variant="primary" />
        </>
      );
      try {
        const {
          data: { token },
        } = await axios.post(`${process.env.REACT_APP_SUNSOFT_SESSION}`, {
          username: process.env.REACT_APP_SESSION_ID,
          password: process.env.REACT_APP_SESSION_CODE,
        });

        body.date = new Date();
        body.time = Date.now();

        const { data: newRecord } = await axios.post(
          `${process.env.REACT_APP_CONTACT_INFO_API}/add`,
          body,
          {
            headers: {
              "Session-Token": token,
              "Content-Type": "application/json",
            },
          }
        );

        let emailObj = {
          toEmailAddress: [`${process.env.REACT_APP_SEND_EMAIL_ADDRESS}`],
          emailSubjectLine: "subscribed to notifications",
          emailBody: "",
        };
        let stringBody = "";
        Object.entries(newRecord).forEach(
          (item) => (stringBody += `${item[0]}: ${item[1]}<br/>`)
        );
        emailObj.emailBody = `<html><body><p>${stringBody}</p></body></html>`;

        const sendEmail = await axios.post(
          process.env.REACT_APP_SEND_EMAIL,
          emailObj
        );
        console.log(sendEmail);
        setModalText(
          <>You are now subscribed to Sun West Mortgage email notifications!</>
        );
        setSubscriberEmail("");
        document
          .querySelector(".subscribe_sign_box")
          .classList.toggle("active");
      } catch (err) {
        console.log(err);
        setModalText(
          <>
            <p className='failtext'>Something went wrong.
              <br /> Please try again later.</p>
          </>
        );
      }
    }
  };
  const handleToggle = (e) => {
    e.target.parentElement.previousElementSibling.classList.toggle("active");
    setModalText("");
  };
  const handleValidEmail = (value) => {
    if (value.length === 0) {
      setValidEmail(true);
      return true;
    } else if (
      value.length > 0 &&
      /^[a-zA-Z0-9.+_-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(value)
    ) {
      setValidEmail(false);
      return false;
    } else {
      setValidEmail(true);
      return true;
    }
  };

  return (
    <div id='subscribe' className="w-100 h-100 d-flex flex-column justify-content-end align-items-end">

      <img src={heroImage} className="banner" alt="Hero" />
      <div className="subscribe_wrapper">
        <Form className="subscribe_sign_box" noValidate>
          <Form.Group className="m-0 p-0">
            <Form.Control
              id="email"
              type="email"
              name="email"
              required
              value={subscriberEmail}
              onChange={(e) => {
                const { value } = e.target;
                setSubscriberEmail(value);
                handleValidEmail(value);
              }}
              isInvalid={validEmail}
              pattern="/^[a-zA-Z0-9.+_-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/"
              placeholder="Your email address"
              className="subscribe_input"
            />
            <Form.Control.Feedback className="valid" type="invalid">
              Please enter a valid email.
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Control
            type="submit"
            onClick={(e) => {
              e.preventDefault();
              handleValidEmail(subscriberEmail);
              if (subscriberEmail !== "" && subscriberEmail.length !== 0)
                handleSubmit(e);
            }}
            value="Subscribe"
            className="subscribe_button"
          />
        </Form>
        <div className="subscribe_box">
          <p onClick={(e) => handleToggle(e)} className="subscribe_text">
            Subscribe for Notifications
          </p>
        </div>
      </div>

      {loading && (
        <Modal
          size="lg"
          onHide={() => {
            setLoading(false);
            setSubscriberEmail("");
          }}
          centered
          show={loading}
          backdrop="static"
        >
          <Modal.Header closeButton />
          <Modal.Body className="text-center">{modalText}</Modal.Body>
        </Modal>
      )}
    </div>
  );
}
